import React, { useState, useContext } from "react";
import LogRocket from "logrocket";
import useApi from "../Api/Api";
import { LoginContext } from "./LoginContextProvider";
import config from "../Config";

export const UserContext = React.createContext();

const UserContextProvider = ({ children }) => {
  const { loginToken } = useContext(LoginContext);

  const api = useApi();
  const [isAdmin, setIsAdmin] = useState(false);
  const [isManager, setIsManager] = useState(false);

  const getIsAdminAndManager = () => {
    api.get("/users/me").then((r) => {
      if (config.logrocket.enabled) {
        LogRocket.identify(r.data.id, {
          name: r.data.name,
          email: r.data.email,
          role: r.data.role,
        });
      }
      setIsAdmin(r.data.role === "administrator");
      setIsManager(r.data.role === "manager");
    });
  };

  if (loginToken !== null) {
    getIsAdminAndManager();
  }

  return (
    <UserContext.Provider
      value={{
        isAdmin,
        setIsAdmin,
        isManager,
        setIsManager,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export default UserContextProvider;
